import { axiosInstance } from '../common/api';

export const performanceData = (data) => {
  const url = `/user/points`;
  const month = data.month;
  const year = data.year;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url, { params: { month, year } })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
